import React from "react";
import monkey from "../images/sadMonkey.jpg";

const OutOfMoves = () => {
  return (
    <div>
      <img style={{ width: "100%", margin: "auto" }} src={monkey} />
    </div>
  );
};

export default OutOfMoves;
